import { CheckIcon } from '@heroicons/react/24/outline'
import { VERIFICATION_STATUSES } from '../../constants/verificationStatuses'
import { VERIFICATION_STEPS } from '../../constants/verificationSteps'

const steps = [
  { label: 'Shop Info', key: 'shop' },
  { label: 'Documents', key: 'documents' },
  { label: 'Location', key: 'location' },
  { label: 'Final Decision', key: 'decision' },
]

export default function VerificationStepper({ currentStepKey, madeFinalDecision }) {
  const currentIndex = steps.findIndex((step) => step.key === currentStepKey)

  return (
    <div className="flex justify-between items-center mb-6 px-2 sm:px-4">
      {steps.map((step, index) => {
        const isCompleted =
          index < currentIndex ||
          (index === currentIndex &&
            step.key === VERIFICATION_STEPS.FINAL_DECISION &&
            madeFinalDecision)
        const isActive = index === currentIndex

        return (
          <div key={step.key} className="flex-1 flex items-center group">
            <div
              className={`relative z-10 w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold
                ${
                  isCompleted
                    ? 'bg-green-500 text-white'
                    : isActive
                    ? 'bg-secondary-600 text-white'
                    : 'bg-neutral-200 text-gray-700'
                }
              `}
            >
              {isCompleted ? <CheckIcon className="w-6 h-6" /> : index + 1}
            </div>

            <div className="ml-2 text-xs sm:text-sm">
              <span
                className={
                  isCompleted
                    ? 'font-semibold text-green-600'
                    : isActive
                    ? 'font-semibold text-secondary-600'
                    : 'text-gray-600'
                }
              >
                {step.label}
              </span>
            </div>

            {index < steps.length - 1 && (
              <div
                className={`flex-1 h-0.5 mx-2 transition-all duration-300 
                ${isCompleted ? 'bg-green-500' : 'bg-neutral-200'}`}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
